import * as React from 'react';
import {withTranslation} from 'react-i18next';
import s from './pageHeader.scss';
import PageCategoryDisplay from '../../containers/PageCategoryDisplay';
import {findSearchTerms} from '../../utils/search';
import {getLabelByPath} from '../../utils';
import {History} from 'history';
import {TopNavigation} from '../Navigation';
import {Experiment} from '../../reducers/experiments';
import {Tags} from '../Tags/Tags';
import {Route, RouteType} from '../../routes/navigation';
import {Button} from '../Subscription';

type PageHeaderProps = {
  t?: (...args: any[]) => any;
  loadArticles: (...args: any[]) => any;
  updateSearch?: (...args: any[]) => any;
  history: History;
  experiments?: Experiment[];
  tags?: Route[];
  routeType?: RouteType;
};
class PageHeader extends React.Component<PageHeaderProps, {}> {
  render() {
    const {t, history, routeType, experiments = []} = this.props;
    const searchTerms = findSearchTerms(history);
    const label = getLabelByPath(history.location.pathname, experiments);
    return (
      <div data-hooks="page-header-component" className={s.layout}>

        <div className={s.headingWrap}>
          <h1
            data-hooks="page-header-title"
            className={s.title}
          >
            {t('main_page_title')}
          </h1>
          <Button />
        </div>

        <TopNavigation
          searchTerms={searchTerms}
          label={label}
          experiments={experiments}
        />
        <div className={s.titleWrap}>
        <PageCategoryDisplay
          history={history}
          label={label}
          searchTerms={searchTerms}
          routeType={routeType}
        />
        <Tags searchTerms={searchTerms}/>
        </div>
      </div>
    );
  }
}
export default withTranslation()(PageHeader);
